export class Collapsible {
  constructor(selector = '[data-toggle="collapse"]') {
    this.$elems = document.querySelectorAll(selector)

    this.collapseToggle = this.collapseToggle.bind(this)
    this.expand = this.expand.bind(this)

    this.init()
  }

  init() {
    if (!this.$elems) return

    this.$elems.forEach(item => {
      item.addEventListener('click', () => {
        this.collapseToggle(item, item.dataset.targetType)
      })
    })
  }

  collapseToggle(trigger, targetType) {
    trigger.classList.toggle('active')

    let target
    if (targetType === 'sibling') {
      target = trigger.parentNode.querySelector('.collapse')
      trigger.parentNode.classList.toggle('active')
    }
    else if (targetType === 'parent') {
      target = trigger.closest('.collapse')
    }
    target.classList.toggle('show')

    this.expand(target)
  }

  expand(el) {
    if (el.style.maxHeight) {
      el.style.maxHeight = null
    } else {
      el.style.maxHeight = el.scrollHeight + 'px'
    }
  }
}



/** Markup example
<div class="faq-item">
  <div class="faq-item__question" data-toggle="collapse" data-target-type="sibling"> // active
      <span>Question</span>
  </div>

  <div class="collapse"> // show
    Answer
  </div>
</div>
 ** */

/** Styles
[data-toggle="collapse"] {
  cursor: pointer;
}

.collapse {
  max-height: 0;
  position: relative;
  overflow: hidden;
  transition: all .35s ease;
}
** */